import React from "react";
import { ApplicationEventHistoryFE } from "../../../../Models/applicationModels";
import { Modal, Spin } from "antd";
import styles from "./eventHistoryModal.module.css";
import { EventHistoryFooter } from "./components/eventHistory/components/eventHistoryFooter/eventHistoryFooter.index";
import { EventHistoryHeader } from "./components/eventHistory/components/eventHistoryHeader/eventHistoryHeader.index";
import { EventHistory } from "./components/eventHistory/eventHistory.index";

interface EventHistoryModalProps {
  isOpen: boolean;
  isLoading: boolean;
  responseData: ApplicationEventHistoryFE | null;
  onClose: () => void;
  onRetry: () => void;
}

const EventHistoryModal: React.FC<EventHistoryModalProps> = ({
  isOpen,
  isLoading,
  responseData,
  onClose,
  onRetry,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={<EventHistoryHeader />}
      footer={<EventHistoryFooter totalEvents={responseData?.eventsResponse?.totalEvents || 0} />}
      width={800}
      centered={true}
      zIndex={1200}
      classNames={{
        header: `${styles.eventHistoryTitleStyles}`,
        container: `${styles.eventHistoryContainerStyles}`,
        body: `${styles.eventHistoryBodyStyles}`,
      }}
    >
      {isLoading ? (
        <Spin />
      ) : (
        <EventHistory eventHistoryDetails={responseData} onRetry={onRetry} />
      )}
    </Modal>
  )
};

export default EventHistoryModal;
